import { Input } from 'antd/';
import React, { ChangeEvent, useCallback } from 'react';
import { CustomFormItem } from '../../custom-form-item';
import { MetadataFormFieldProps } from '../types';


export const IntegerField: React.FC<MetadataFormFieldProps> = (props) => {
  const {
          validationStatus,
          value,
          label,
          disabled,
          onChange,
          required
        } = props;

  const internalOnChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const v = e.target.value;

      if (v) {
        const next = parseInt(v, 10);

        if (!isNaN(next)) {
          return onChange(next);
        }

        return onChange(null);
      }

      onChange(v || null);
    },
    [onChange],
  );

  return (
    <CustomFormItem
      label={label}
      validateStatus={validationStatus}
      required={required}
    >
      <Input
        type="number"
        step="1"
        disabled={disabled}
        value={value}
        onChange={internalOnChange}
        allowClear
      />
    </CustomFormItem>
  );
};
